module.exports = __webpack_public_path__ + "img/zhuanke.7a6e0042.png";